import React, {useEffect} from 'react';
import {Navbar, Container} from "react-bootstrap";
import {motion} from "framer-motion"

import Icon from '@mdi/react';
import { mdiMap, mdiLayers, mdiCrosshairs, mdiInformationOutline  } from '@mdi/js';

import styles from './MobileFooter.scss'

import {connect} from "react-redux";

const MobileFooter = (props) => {


    const handleClickLink = (evt)=>{
        if(evt){
            window.top.location.href = evt;
        }
    }

    useEffect(()=> {
           // (props.windowsSize>=769)?props.setDisplayMapTools():props.setDisplayMapTools(false);
    },[props.windowsSize ])

    const handleNav = (evt,linkData)=>{
        //setSubMenu(linkData.name);
        switch(linkData.type){
            case "url":
                handleClickLink(linkData.link);
                break;
            case "float":
                if(linkData.name==="search"){
                    props.setLeftPanelOpen(false);
                    props.showCenterSection(false);
                    props.setShowSearchPanel(!props.showSearchTools)
                }
                break;
            case "panel":
                props.showCenterSection(false)
                if(linkData.name===props.currentSection){
                    props.setOpenPrintControl(false);
                    props.setLeftPanelOpen(false);
                    props.showCurrentSection('none');
                    props.showCenterSection(false);

                }else if(linkData.name==="print") {
                    props.setOpenPrintControl(!props.openPrintControl);
                    props.setLeftPanelOpen(false);
                }else if(linkData==="search"){
                    props.setLeftPanelOpen(false)
                    props.setShowSearchPanel(!props.showSearchTools)
                }else if(linkData.name!=="map"){
                    props.showCurrentSection(linkData.name)
                    props.setLeftPanelOpen(true);
                }else {
                    props.showCurrentSection(linkData.name)
                    props.setShowSearchPanel(false)
                    props.setLeftPanelOpen(false);
                }
                break;
            case "center":
                props.setLeftPanelOpen(false)
                if(props.userId || linkData.name === "product" ){
                    props.setCurrentCenterPage(linkData.name)
                    props.showCenterSection('center_zone')
                }
                break;
            default:
                return;
        }
    }


    return (
        <Navbar fixed="bottom"   className={'d-block d-md-none text-light ueMobileFooter'}  expand="lg" variant="dark" bg="dark">
            <Container >
                <button className={'btn ueMobileFooterBtnName'}
                        onClick={(e)=>handleNav(e,{"type":"panel","name":"map"})}
                >
                    <Icon path={mdiMap}  size={1.15}   color={(props.currentSection==='map')?'#FFF':'#C1C1C1'} />
                    <div className={'ueMobileFooterBtnName'}>Carte</div>
                </button>
                <button
                    className={'btn ueMobileFooterBtn'}
                    onClick={(e)=>handleNav(e,{"type":"panel","name":"layers"})}
                     >
                    <Icon path={mdiLayers}  size={1.15}
                          color={(props.currentSection==='layers')?'#FFF':'#C1C1C1'}
                    />
                    <div className={'ueMobileFooterBtnName'}>Donnée</div>
                </button>
                <button className={'btn ueMobileFooterBtne'}
                        onClick={(e)=>handleNav(e,{"type":"float","name":"search"})}
                >
                    <Icon path={mdiCrosshairs}  size={1.15}
                          color={(props.currentSection==='search')?'#FFF':'#C1C1C1'}
                    />
                    <div className={'ueMobileFooterBtnName'}>Recherche</div>
                </button>
                <button className={'btn ueMobileFooterBtn'}
                        onClick={(e)=>handleNav(e,{"type":"panel","name":"data"})}
                >
                    <Icon path={mdiInformationOutline}  size={1.15}
                          color={(props.currentSection==='data')?'#FFF':'#C1C1C1'}
                    />
                    <div className={'ueMobileFooterBtnName'}>Information</div>
                </button>
                <button className={'btn ueMobileFooterBtn'}
                        onClick={()=>{props.setDisplayMapTools(!props.displayMapTools)}}
                >
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" >
                        <path  d="M9.50001 0.500041C9.03621 0.501443 8.58423 0.646384 8.20611 0.914961C7.82799 1.18354 7.54229 1.56258 7.38823 2.00004H4.86178C4.73595 1.64204 4.5214 1.32178 4.23819 1.06921C3.95497 0.81664 3.61234 0.640004 3.24233 0.555813C2.87231 0.471621 2.48699 0.482624 2.12238 0.587792C1.75776 0.69296 1.42577 0.888859 1.15743 1.15718C0.889093 1.4255 0.693168 1.75747 0.587971 2.12208C0.482774 2.48668 0.471741 2.872 0.555904 3.24202C0.640066 3.61205 0.816675 3.95469 1.06922 4.23792C1.32177 4.52116 1.64201 4.73573 2 4.86159V7.38812C1.49959 7.56504 1.07784 7.91317 0.809281 8.37098C0.540723 8.82878 0.442654 9.36679 0.532408 9.88991C0.622161 10.413 0.893958 10.8876 1.29976 11.2297C1.70556 11.5718 2.21924 11.7594 2.75 11.7594C3.28077 11.7594 3.79445 11.5718 4.20025 11.2297C4.60605 10.8876 4.87785 10.413 4.9676 9.88991C5.05735 9.36679 4.95929 8.82878 4.69073 8.37098C4.42217 7.91317 4.00042 7.56504 3.5 7.38812V4.86197C3.81375 4.75009 4.09869 4.56985 4.33421 4.3343C4.56973 4.09876 4.74993 3.8138 4.86178 3.50004H7.38823C7.52643 3.88785 7.76857 4.23021 8.08818 4.48971C8.40779 4.74921 8.79258 4.91588 9.2005 4.9715C9.60842 5.02711 10.0238 4.96954 10.4012 4.80507C10.7786 4.6406 11.1036 4.37556 11.3405 4.03891C11.5775 3.70225 11.7174 3.30694 11.7449 2.89617C11.7724 2.48539 11.6865 2.07496 11.4966 1.70971C11.3066 1.34446 11.0199 1.03845 10.6678 0.825111C10.3157 0.611776 9.9117 0.499323 9.50001 0.500041V0.500041ZM2.75 10.25C2.60167 10.25 2.45666 10.2061 2.33333 10.1236C2.20999 10.0412 2.11386 9.9241 2.05709 9.78705C2.00033 9.65001 1.98548 9.49921 2.01442 9.35372C2.04335 9.20824 2.11479 9.0746 2.21967 8.96971C2.32456 8.86482 2.4582 8.79339 2.60369 8.76445C2.74917 8.73551 2.89997 8.75036 3.03702 8.80713C3.17406 8.8639 3.2912 8.96003 3.37361 9.08336C3.45602 9.2067 3.5 9.3517 3.5 9.50004C3.49985 9.6989 3.42078 9.88958 3.28016 10.0302C3.13954 10.1708 2.94887 10.2499 2.75 10.25V10.25ZM2.75 3.50004C2.60167 3.50004 2.45666 3.45605 2.33333 3.37364C2.20999 3.29123 2.11386 3.1741 2.05709 3.03705C2.00033 2.90001 1.98548 2.74921 2.01442 2.60372C2.04335 2.45824 2.11479 2.3246 2.21967 2.21971C2.32456 2.11482 2.4582 2.04339 2.60369 2.01445C2.74917 1.98551 2.89997 2.00037 3.03702 2.05713C3.17406 2.1139 3.2912 2.21003 3.37361 2.33336C3.45602 2.4567 3.5 2.6017 3.5 2.75004C3.49985 2.9489 3.42078 3.13958 3.28016 3.2802C3.13954 3.42081 2.94887 3.49988 2.75 3.50004V3.50004ZM9.50001 3.50004C9.35167 3.50004 9.20666 3.45605 9.08333 3.37364C8.95999 3.29123 8.86386 3.1741 8.8071 3.03705C8.75033 2.90001 8.73548 2.74921 8.76442 2.60372C8.79335 2.45824 8.86479 2.3246 8.96968 2.21971C9.07456 2.11482 9.2082 2.04339 9.35369 2.01445C9.49917 1.98551 9.64997 2.00037 9.78702 2.05713C9.92406 2.1139 10.0412 2.21003 10.1236 2.33336C10.206 2.4567 10.25 2.6017 10.25 2.75004C10.2498 2.9489 10.1708 3.13958 10.0302 3.2802C9.88954 3.42081 9.69887 3.49988 9.50001 3.50004V3.50004Z"
                               className="stroke-2"
                               style={{stroke:'#C1C1C1',strokeWidth:'3%'}}
                               fill="#C1C1C1"/>
                    </svg>
                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path  d="M20.6211 1.3789C20.0498 0.833122 19.2901 0.528564 18.5 0.528564C17.7099 0.528564 16.9502 0.833122 16.3789 1.3789L2.03749 15.719C1.54852 16.2053 1.16086 16.7838 0.89695 17.4209C0.633038 18.0581 0.498115 18.7412 0.499989 19.4309V21.5H2.56691C3.25666 21.502 3.93996 21.3671 4.57722 21.1032C5.21448 20.8393 5.79305 20.4516 6.27941 19.9625L20.6211 5.62142C20.8997 5.3429 21.1208 5.01221 21.2716 4.64823C21.4224 4.28426 21.5 3.89414 21.5 3.50016C21.5 3.10618 21.4224 2.71606 21.2716 2.35209C21.1208 1.98812 20.8997 1.65742 20.6211 1.3789ZM7.18249 12.695L9.30394 14.8164L7.71289 16.4075L5.59144 14.2863L7.18249 12.695ZM5.21861 18.9017C4.87121 19.251 4.45797 19.528 4.0028 19.7165C3.54763 19.905 3.05958 20.0014 2.56691 20H1.99999V19.4309C1.99866 18.9383 2.09505 18.4503 2.28358 17.9952C2.4721 17.5401 2.74901 17.1269 3.09829 16.7795L4.53079 15.347L6.65224 17.4681L5.21861 18.9017ZM19.5606 4.56055L10.3646 13.7561L8.24314 11.6346L17.4394 2.43962C17.7251 2.16676 18.1049 2.01449 18.5 2.01449C18.895 2.01449 19.2749 2.16676 19.5606 2.43962C19.6999 2.57888 19.8104 2.74422 19.8858 2.9262C19.9612 3.10818 20 3.30322 20 3.5002C20 3.69717 19.9612 3.89222 19.8858 4.0742C19.8104 4.25617 19.6999 4.42151 19.5606 4.56077V4.56055Z"
                               style={{stroke:'#C1C1C1',strokeWidth:'3%'}}
                               fill="#C1C1C1"/>
                    </svg>
                    <div className={'ueMobileFooterBtnName'}>Outils</div>
                </button>
            </Container>
        </Navbar>
    );
};



const mapStateToProps = state => {
    return {
        userId: state.MeReducer.id,
        currentSection : state.LeftPanelReducer.showCurrentSection,
        role : state.MeReducer.role,
        leftNavWidth : state.LeftPanelReducer.leftNavWidth,
        leftMenuIsOpen: state.LeftPanelReducer.leftMenuIsOpen,
        leftPanelWidth: state.LeftPanelReducer.leftNavWidth,
        leftPanelIsOpen: state.LeftPanelReducer.leftPanelIsOpen,
        openPrintControl: state.PrintReducer.openPrintControl,
        showSearchTools: state.LeftPanelReducer.showSearchTools,
        displayMapTools: state.MapReducer.displayMapTools,
        windowsSize: state.AppReducer.windowsSize,
    }
}

const mapDispatchTProps = dispatch => {
    return {
        showCurrentSection: (e) => dispatch( {type: 'SHOW_CURRENT_SECTION', data:e}),
        setLeftMenuOpen : (e) => dispatch({type: 'SET_LEFT_MENU_OPEN', data:e }),
        setLeftPanelWidth : (e) => dispatch({type: 'SET_LEFT_PANEL_WIDTH', data:e }),
        setLeftPanelOpen : (e) => dispatch({type: 'SET_LEFT_PANEL_OPEN', data:e }),
        setCurrentCenterPage: (e) => dispatch({type: 'SET_CURRENT_PAGE', data:e}),
        showCenterSection: (e) => dispatch( {type: 'SHOW_CENTER_SECTION', data:e}),
        setOpenPrintControl: (e) => dispatch( {type: 'OPEN_PRINT_CONTROL', data:e}),
        setShowSearchPanel: (e) => dispatch( {type: 'SHOW_SEARCH_PANEL', data:e}),
        setDisplayMapTools: (e)=> dispatch({type: 'SET_DISPLAY_MAP_TOOLS', data:e})
    }
}


export default connect(mapStateToProps, mapDispatchTProps)(MobileFooter);

